import { FiUser, FiUsers, FiGlobe } from 'react-icons/fi';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

const AUDIENCES = [
  {
    icon: FiUser,
    title: 'Individual professionals',
    description:
      'Consultants, writers, analysts, and knowledge workers who want a private AI assistant for research, drafting, and document review.',
  },
  {
    icon: FiUsers,
    title: 'Small and growing teams',
    description:
      'Companies rolling out AI access to a handful of people who need it managed under one account, not scattered across personal subscriptions.',
  },
  {
    icon: FiGlobe,
    title: 'Larger organizations',
    description:
      'Enterprises that need centralized control over who has AI access, what plan they\'re on, and visibility into how much sensitive information is being filtered out across the company.',
  },
];

export default function WhoItsForSection() {
  return (
    <section className="bg-surface py-24 dark:bg-midnight-800">
      <div className="container-page flex flex-col items-center gap-14">
        <SectionHeading eyebrow="Who it's for" title="Built for individuals, teams, and entire organizations" />

        <div className="grid w-full grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal className="order-2 lg:order-1">
            <img
              src="/piua2.jpeg"
              alt="A Piua AI user checking the chat assistant on their phone next to their laptop"
              className="w-full rounded-2xl border border-line object-cover shadow-card dark:border-midnight-600"
              loading="lazy"
            />
          </Reveal>

          <div className="order-1 flex flex-col gap-5 lg:order-2">
            {AUDIENCES.map((item, index) => (
              <Reveal key={item.title} delay={index * 0.1} className="card flex items-start gap-4 p-6">
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-brand-gradient text-white">
                  <item.icon size={20} />
                </span>
                <div>
                  <h3 className="text-lg font-bold text-ink dark:text-white">{item.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted dark:text-subtle">{item.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
